/* eslint-disable max-len */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/modules/shared.module';
import { AppPrimengModule } from 'app/app-primeng-module';
import { CardModule } from 'app/components/card/card.module';
import { BannedUserComponent } from 'app/components/home/customers/banned-user/banned-user.component';
import { CustomerInfoComponent } from 'app/components/home/customers/customer-info/customer-info.component';
import { CustomerOrderDetailComponent } from 'app/components/home/customers/customer-info/customer-order-detail/customer-order-detail.component';
import { CustomerTransactionDetailComponent } from 'app/components/home/customers/customer-info/customer-transaction-detail/customer-transaction-detail.component';
import {
	CustomerManageDiscountDialogComponent
} from 'app/components/home/customers/customer-info/customer-manage-discount-dialog/customer-manage-discount-dialog.component';
import { DriversComponent } from 'app/components/home/drivers/drivers.component';
import { DriversFilterComponent } from 'app/components/home/drivers/drivers-filter/drivers-filter.component';
import { DriverAddComponent } from 'app/components/home/drivers/driver-add/driver-add.component';
import {
	DriversCompaignExportSidebarComponent
} from 'app/components/home/drivers/drivers-compaign/drivers-compaign-export-sidebar/drivers-compaign-export-sidebar.component';
import { DriverDetailComponent } from 'app/components/home/drivers/driver-detail/driver-detail.component';
import { DriverOrderDetailComponent } from 'app/components/home/drivers/driver-detail/driver-order-detail/driver-order-detail.component';
import { DriverTransactionDetailComponent } from 'app/components/home/drivers/driver-detail/driver-transaction-detail/driver-transaction-detail.component';
import { DriverPayoutInvoiceComponent } from 'app/components/home/drivers/driver-detail/driver-payout-invoice/driver-payout-invoice.component';
import { DriverUploadDocDialogComponent } from 'app/components/home/drivers/driver-detail/driver-upload-doc-dialog/driver-upload-doc-dialog.component';
import { VehicleOwnerDetailComponent } from 'app/components/home/drivers/driver-detail/vehicle-owner-detail/vehicle-owner-detail.component';
import { EditVehicleModalComponent } from 'app/components/home/drivers/driver-detail/edit-vehicle-modal/edit-vehicle-modal.component';
import { DriverCommerceComponent } from 'app/components/home/drivers/driver-detail/driver-commerce/driver-commerce.component';
import { ProductTransactionsComponent } from 'app/components/home/drivers/driver-detail/driver-commerce/product-transactions/product-transactions.component';
import { ProductDetailsComponent } from 'app/components/home/drivers/driver-detail/driver-commerce/product-details/product-details.component';
import {
	AddAvailedProductDialogComponent
} from 'app/components/home/drivers/driver-detail/driver-commerce/add-availed-product-dialog/add-availed-product-dialog.component';
import {
	AddAvailedProductDetailsComponent
} from 'app/components/home/drivers/driver-detail/driver-commerce/add-availed-product-dialog/add-availed-product-details/add-availed-product-details.component';
import {
	AddAvailedProductPaymentTermsComponent
} from 'app/components/home/drivers/driver-detail/driver-commerce/add-availed-product-dialog/add-availed-product-payment-terms/add-availed-product-payment-terms.component';
import { UploadProductsDialogComponent } from 'app/components/home/drivers/driver-detail/driver-commerce/upload-products-dialog/upload-products-dialog.component';
import {
	AddAvailedProductSummaryComponent
} from 'app/components/home/drivers/driver-detail/driver-commerce/add-availed-product-dialog/add-availed-product-summary/add-availed-product-summary.component';
import {
	EditAvailedProductDialogComponent
} from 'app/components/home/drivers/driver-detail/driver-commerce/product-details/edit-availed-product-dialog/edit-availed-product-dialog.component';
import {
	EditAvailedProductStatusComponent
} from 'app/components/home/drivers/driver-detail/driver-commerce/product-details/edit-availed-product-dialog/edit-availed-product-status/edit-availed-product-status.component';
import {
	EditAvailedProductDetailsComponent
} from 'app/components/home/drivers/driver-detail/driver-commerce/product-details/edit-availed-product-dialog/edit-availed-product-details/edit-availed-product-details.component';
import {
	EditAvailedProductConfirmComponent
} from 'app/components/home/drivers/driver-detail/driver-commerce/product-details/edit-availed-product-confirm/edit-availed-product-confirm.component';
import { SendLogsRequestComponent } from '@shared/components/customer/send-logs-request/send-logs-request.component';
import { DisciplinarySharedModule } from 'app/components/home/home-disciplinary/disciplinary-shared.module';
import { PhoneMaskPipe } from 'app/components/home/drivers/pipes/phone-mask.pipe';
import { FilesizePipe } from 'app/components/home/drivers/driver-detail/driver-commerce/pipes/filesize.pipe';

@NgModule({
	declarations: [
		DriversComponent,
		DriversFilterComponent,
		DriverAddComponent,
		DriversCompaignExportSidebarComponent,
		DriverDetailComponent,
		DriverOrderDetailComponent,
		DriverTransactionDetailComponent,
		DriverPayoutInvoiceComponent,
		DriverUploadDocDialogComponent,
		VehicleOwnerDetailComponent,
		EditVehicleModalComponent,
		DriverCommerceComponent,
		ProductTransactionsComponent,
		ProductDetailsComponent,
		AddAvailedProductDialogComponent,
		AddAvailedProductDetailsComponent,
		AddAvailedProductPaymentTermsComponent,
		UploadProductsDialogComponent,
		AddAvailedProductSummaryComponent,
		EditAvailedProductDialogComponent,
		EditAvailedProductStatusComponent,
		EditAvailedProductDetailsComponent,
		EditAvailedProductConfirmComponent,
		CustomerInfoComponent,
		BannedUserComponent,
		CustomerTransactionDetailComponent,
		CustomerOrderDetailComponent,
		CustomerManageDiscountDialogComponent,
		SendLogsRequestComponent,
		PhoneMaskPipe,
		FilesizePipe
	],
	imports: [
		CommonModule,
		FormsModule,
		SharedModule,
		AppPrimengModule,
		CardModule,
		DisciplinarySharedModule
	],
	exports: [
		DriversComponent,
		DriversFilterComponent,
		DriverAddComponent,
		DriversCompaignExportSidebarComponent,
		DriverDetailComponent,
		DriverOrderDetailComponent,
		DriverTransactionDetailComponent,
		DriverPayoutInvoiceComponent,
		DriverUploadDocDialogComponent,
		VehicleOwnerDetailComponent,
		DriverCommerceComponent,
		ProductTransactionsComponent,
		ProductDetailsComponent,
		DisciplinarySharedModule,
		CustomerInfoComponent,
		BannedUserComponent,
		CustomerTransactionDetailComponent,
		CustomerOrderDetailComponent,
		CustomerManageDiscountDialogComponent,
		SendLogsRequestComponent,
		PhoneMaskPipe
	]
})
export class DriversSharedModule { }
